import {Component, model, ModelSignal} from '@angular/core';
import {NgIf} from "@angular/common";
import {DynamicFormComponent, DynamicFormControlComponent, IAction} from 'frontier/browserkit';
import {MatError} from "@angular/material/form-field";
import LibControlGuids from "frontier/nucleus/src/lib/apiv2/ControlGuids";
import {
  JSON_EXPORT_ACTION,
  JSON_IMPORT_ACTION,
} from "frontier/browserkit/src/lib/components/control/table-control/default-form-actions.constant";

@Component({
  selector: 'app-global-customer-settings-form',
  templateUrl: '../../../../../projects/frontier/browserkit/src/lib/components/control/form-control/dynamic-form/dynamic-form-control/dynamic-form-control.component.html',
  styleUrl: '../../../../../projects/frontier/browserkit/src/lib/components/control/form-control/dynamic-form/dynamic-form-control/dynamic-form-control.component.scss',
  standalone: true,
  imports: [NgIf, DynamicFormComponent, MatError],
})
export class GlobalCustomerSettingsFormComponent extends DynamicFormControlComponent {
  override GUID: string = LibControlGuids.TCustomerSettingsForm;
  override actions: ModelSignal<IAction[]> = model<IAction[]>([
    JSON_EXPORT_ACTION,
    JSON_IMPORT_ACTION,
  ]);
}
